/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_PUBLISH_PROJECT, PUBLISH_PROJECT_RECEIVED } = constants.publishProjectConstants;

export default {
    REQUEST_PUBLISH_PROJECT,
    PUBLISH_PROJECT_RECEIVED,

  requestPublishProject: payload => ({
    type: REQUEST_PUBLISH_PROJECT,
    payload
  }),
  publishProjectReceived: () => ({
    type: PUBLISH_PROJECT_RECEIVED
  }),
};
